// src/pages/cadastros/Empresas/EditarEmpresa.jsx
// (Mamute Fitness) UI rebatizado para "Clientes".
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useTheme } from "../../../contexts/ThemeContext";
import { useAuth } from "../../../contexts/AuthContext";
import LayoutDesktop from "../../../layouts/LayoutDesktop";

import { temNivelMinimo } from "../../../utils/permissoes";
import { NIVEIS } from "../../../config/niveis";
import { abrirPreventivasCliente } from "../../../services/abrirPreventivasClienteApi";

import { db } from "../../../config/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";

function EditarEmpresa() {
  const { tema } = useTheme();
  const { usuario: usuarioLogado } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();

  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [abrindoPreventivas, setAbrindoPreventivas] = useState(false);
  const [erro, setErro] = useState("");
  const [sucessoPreventivas, setSucessoPreventivas] = useState("");

  const [codigo, setCodigo] = useState("");
  const [nome, setNome] = useState("");
  const [endereco, setEndereco] = useState("");
  const [responsavel, setResponsavel] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [tipo, setTipo] = useState("Propria");
  const [grupoNome, setGrupoNome] = useState("");

  useEffect(() => {
    async function carregar() {
      setCarregando(true);
      setErro("");

      try {
        const ref = doc(db, "empresas", id);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          setErro("Cliente não encontrado.");
          return;
        }

        const dados = snap.data();

        setCodigo(dados.codigo || "");
        setNome(dados.nome || "");
        setEndereco(dados.endereco || "");
        setResponsavel(dados.responsavel || "");
        setTelefone(dados.telefone || "");
        setEmail(dados.email || "");
        setTipo(dados.tipo || "Propria");
        setGrupoNome(dados.grupoNome || dados.grupoId || "");
      } catch (e) {
        console.error("Erro ao carregar cliente:", e);
        setErro("Erro ao carregar cliente. Tente novamente.");
      } finally {
        setCarregando(false);
      }
    }

    if (id) carregar();
  }, [id]);

  async function handleSubmit(e) {
    e.preventDefault();
    setErro("");

    if (!nome.trim()) {
      setErro("Informe o nome do cliente.");
      return;
    }

    setSalvando(true);

    try {
      const ref = doc(db, "empresas", id);
      await updateDoc(ref, {
        grupoId: usuarioLogado?.grupoId || null,
        grupoNome: grupoNome.trim() || usuarioLogado?.grupoNome || usuarioLogado?.grupo || null,

        nome: nome.trim(),
        endereco: endereco.trim() || null,
        responsavel: responsavel.trim() || null,
        telefone: telefone.trim() || null,
        email: email.trim() || null,
        tipo: tipo || null,
      });

      alert("Cliente atualizado com sucesso.");
      navigate("/cadastros/clientes");
    } catch (e) {
      console.error("Erro ao atualizar cliente:", e);
      setErro("Erro ao atualizar cliente. Tente novamente.");
    } finally {
      setSalvando(false);
    }
  }

  async function handleAbrirPreventivas() {
    setErro("");
    setSucessoPreventivas("");

    if (!usuarioLogado?.grupoId || !id) {
      setErro("Grupo/cliente não identificado.");
      return;
    }

    if (!temNivelMinimo(usuarioLogado, NIVEIS.ADMIN)) {
      setErro("Apenas Administrador/Gestor pode abrir preventivas do cliente.");
      return;
    }

    const confirma = window.confirm(
      "Abrir preventivas para todos os equipamentos deste cliente?\n\nIsso irá: (1) criar preventivas faltantes e (2) preencher a primeira data (proximaData) onde estiver vazio."
    );
    if (!confirma) return;

    const hojeIso = new Date().toISOString().slice(0, 10);
    const dataStr = window.prompt(
      "Informe a data da PRIMEIRA VISITA (AAAA-MM-DD).\n\nEssa data será gravada em proximaData para as preventivas que ainda não têm data.",
      hojeIso
    );
    if (dataStr == null) return;
    const primeiraData = new Date(`${String(dataStr).trim()}T00:00:00`);
    if (Number.isNaN(primeiraData.getTime())) {
      setErro("Data inválida. Use o formato AAAA-MM-DD.");
      return;
    }

    setAbrindoPreventivas(true);
    try {
      const res = await abrirPreventivasCliente({
        grupoId: usuarioLogado.grupoId,
        clienteId: id,
        clienteNome: nome || "",
        referencia: primeiraData,
        criadoPor: usuarioLogado.uid || "",
      });

      setSucessoPreventivas(
        `Preventivas abertas com sucesso. Criadas: ${res.criadas}. Datas preenchidas: ${res.datasPreenchidas}. Equipamentos verificados: ${res.maquinas}.`
      );
    } catch (e) {
      console.error("Erro ao abrir preventivas:", e);
      setErro(e?.message ? `Erro ao abrir preventivas: ${e.message}` : "Erro ao abrir preventivas.");
    } finally {
      setAbrindoPreventivas(false);
    }
  }

  return (
    <LayoutDesktop
      tema={tema}
      titulo="Editar Cliente"
      subtitulo="Cadastros / Clientes / Editar"
    >
      <section className="pc-card pc-form-card">
        <header className="pc-form-header">
          <h3>Editar dados do cliente</h3>
          <p>Altere apenas as informações necessárias. Código e grupo são apenas leitura.</p>
        </header>

        {carregando ? (
          <p style={{ padding: 10 }}>Carregando dados...</p>
        ) : (
          <form onSubmit={handleSubmit} className="pc-form">
            {erro && (
              <div
                style={{
                  background: "#7f1d1d",
                  color: "#fecaca",
                  padding: 8,
                  borderRadius: 8,
                  marginBottom: 12,
                  fontSize: 14,
                }}
              >
                {erro}
              </div>
            )}

            {sucessoPreventivas && (
              <div
                style={{
                  background: "#15803d",
                  color: "#bbf7d0",
                  padding: 8,
                  borderRadius: 8,
                  marginBottom: 12,
                  fontSize: 14,
                }}
              >
                {sucessoPreventivas}
              </div>
            )}

            <div className="pc-form-grid">
              <div className="pc-form-group">
                <label>Código</label>
                <input type="text" value={codigo} readOnly className="pc-input" />
              </div>

              <div className="pc-form-group">
                <label>Grupo</label>
                <input type="text" value={grupoNome} readOnly className="pc-input" />
              </div>

              <div className="pc-form-group pc-form-group-full">
                <label htmlFor="nome">Nome *</label>
                <input
                  id="nome"
                  type="text"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  className="pc-input"
                />
              </div>

              <div className="pc-form-group">
                <label htmlFor="responsavel">Responsável</label>
                <input
                  id="responsavel"
                  type="text"
                  value={responsavel}
                  onChange={(e) => setResponsavel(e.target.value)}
                  className="pc-input"
                />
              </div>

              <div className="pc-form-group">
                <label htmlFor="telefone">Telefone</label>
                <input
                  id="telefone"
                  type="text"
                  value={telefone}
                  onChange={(e) => setTelefone(e.target.value)}
                  className="pc-input"
                />
              </div>

              <div className="pc-form-group pc-form-group-full">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="pc-input"
                />
              </div>

              <div className="pc-form-group pc-form-group-full">
                <label htmlFor="endereco">Endereço</label>
                <input
                  id="endereco"
                  type="text"
                  value={endereco}
                  onChange={(e) => setEndereco(e.target.value)}
                  className="pc-input"
                />
              </div>

              <div className="pc-form-group">
                <label htmlFor="tipo">Tipo</label>
                <select
                  id="tipo"
                  value={tipo}
                  onChange={(e) => setTipo(e.target.value)}
                  className="pc-input"
                >
                  <option value="Rede">Rede</option>
                  <option value="Propria">Propria</option>
                  <option value="CT">CT</option>
                  <option value="Condominio">Condominio</option>
                  <option value="Clinica">Clinica</option>
                  <option value="Studio">Studio</option>
                  <option value="Marca">Marca</option>
                </select>
              </div>
            </div>

            <div className="pc-form-actions">
              <button
                type="button"
                className="pc-btn-secundario"
                onClick={() => navigate("/cadastros/clientes")}
                disabled={salvando || abrindoPreventivas}
              >
                Voltar
              </button>

              <button
                type="button"
                className="pc-btn-secundario"
                onClick={handleAbrirPreventivas}
                disabled={salvando || abrindoPreventivas || carregando}
                title="Cria preventivas faltantes e preenche a primeira data (proximaData)"
              >
                {abrindoPreventivas ? "Abrindo Preventivas..." : "Abrir Preventivas"}
              </button>

              <button type="submit" className="pc-btn-primario" disabled={salvando}>
                {salvando ? "Salvando..." : "Salvar alterações"}
              </button>
            </div>
          </form>
        )}
      </section>
    </LayoutDesktop>
  );
}

export default EditarEmpresa;
